import { slugify } from "./slugify"

function sender(obj) {
  try {
    if(typeof window === 'undefined') {
      return; // in case of html pre-render (Gatsby), there is no window instance available, and no lurker event will be dispatched
    }
    if (!window.Lurker) {
      console.log("LURKER DEBUG: ", obj)
      if (window.beforeLurkerLoadEvents) {
        window.beforeLurkerLoadEvents.push(obj)
      } else {
        window.beforeLurkerLoadEvents = [obj]
      }
    } else {
      window.Lurker.send({...obj})
    }
  } catch (e) {
    console.log("Failed")
  }

}

function impressionsTracking(objName, objDetail, objClass, response, customTag) {
  try {
    let impressionViewableCheck = false
    let impressionCheck = false

    const sendLurker = (eventType) => {
      let data = {}

      const ads = response
          .map(resp => resp.content)
          .flat()
          .map(item => item.list_id)

      const galleryId = response.map(resp => resp.gallery_id)

      data = {
        ads: JSON.stringify(ads),
        custom_tag: customTag,
        gallery_id: slugify(JSON.stringify(galleryId))
      }

      sender({
        event_type: eventType,
        object_name: objName,
        object_detail: objDetail,
        data
      })
    }

    const isView = () => {
      let recommendationElement = getElementByAttributeValue("object_name", objName, objClass)

      if (!recommendationElement) {
        return false
      }

      let componentCenter = recommendationElement.offsetTop + recommendationElement.offsetHeight/2
      let windowY = window.scrollY;
      return (componentCenter < windowY + window.innerHeight && windowY < componentCenter)
    };

    if (isView()) {
      impressionViewableCheck = true;
      sendLurker('impression_viewable');
    }

    window.addEventListener('scroll', () => {
      if (isView() && !impressionViewableCheck) {
        impressionViewableCheck = true;
        sendLurker('impression_viewable');
      }
    });

    if (!impressionCheck) {
      impressionCheck = true;
      sendLurker('impression');
    }
  } catch (e) {
    console.log("Failed")
  }
}

function clickTracking(objName, objDetail, data) {

  sender({
    event_type: 'click',
    object_name: objName,
    object_detail: objDetail,
    data
  });
}

function failureTracking(objName, objDetail, data) {

  sender({
    event_type: 'impression_failure',
    object_name: objName,
    object_detail: objDetail,
    data
  });
}

function getElementByAttributeValue(attribute, value, className) {
  var All = document.getElementsByClassName(className);
  for (let i = 0; i < All.length; i++)       {
    if (All[i].getAttribute(attribute) === value) { return All[i]; }
  }
}

function eventTracking(objName, eventType, objDetail, data) {
  sender({
    event_type: eventType,
    object_name: objName,
    object_detail: objDetail,
    data
  });
}


export { impressionsTracking, clickTracking, failureTracking, eventTracking }


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/utils/tracking.js